<template>
    <b-modal
        id="ModalContactUpdateInstallation"
        size="md"
        title="Modifier une installation"
        header-bg-variant="kalkin-1"
        header-text-variant="light"
        hide-footer
    >
        <FormContactInstallation
            :project-id="projectId"
            :installation="installation"
            @saved="onSaved"
        />
    </b-modal>
</template>
<script>
import FormContactInstallation from "@/components/model/installation/FormContactInstallation";
export default {
    components: {
        FormContactInstallation,
    },

    props: {
        installation: { type: Object, required: true },
        projectId: { type: [String, Number], required: true },
    },

    methods: {
        onSaved() {
            this.$bvModal.hide("ModalContactUpdateInstallation");
            this.$emit("saved");
        },
    },
};
</script>
